<template>
  <div>
    <div>
      <InfoInfraComponent
        v-if="modalInfraction"
        :obj="infraction"
        :close="closeModals"
        :reload="fetchInfractions"
      />
    </div>
    <div>
      <div class="filterMultas">
        <input
          v-model="searchedQuery"
          @input="resetPagination"
          type="text"
          inputmode="text"
          autocomplete="off"
          @compositionend="forceUpdate"
          class="form-select"
          placeholder="busque por número de acta o patente"
        />
      </div>
      <div v-if="!loading">
        <table v-if="!isMobile" class="custom-table">
          <thead>
            <tr>
              <th>Acta</th>
              <th>Patente</th>
              <th>Monto</th>
              <th>Estado</th>
              <th style="display: none"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="multa in filteredInfractions" :key="multa.id">
              <td>
                {{
                  multa.infraType.type +
                  multa.act.act_number.toString().padStart(6, "0")
                }}
              </td>
              <td>{{ multa.act.plate }}</td>
              <td>${{ formatPrice(multa.cost) }}</td>
              <td
                :style="{
                  background: `${getStateColor(multa.currentState.state.state_name)}`,
                }"
              >
                {{ capitalizeFirstLetter(multa.currentState.state.state_name) }}
              </td>
              <td
                @click="InfractionInfo(multa.id)"
                style="cursor: pointer; background: #d4145a"
              >
                Ver
                <img
                  src="@/assets/images/openInNew.svg"
                  alt=""
                  style="width: 21px; height: 21px"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="tarjetas-grid">
          <div
            v-for="multa in filteredInfractions"
            :key="multa.id"
            class="cardTramites-mobile"
            @click="InfractionInfo(multa.id)"
          >
            <div class="card-body-mobile">
              <div class="card-row">
                <div>
                  <p>
                    <b>Número de Acta: </b
                    >{{
                      multa.infraType.type +
                      multa.act.act_number.toString().padStart(6, "0")
                    }}
                  </p>
                </div>
                <div>
                  <p><b>Dominio:</b> {{ multa.act.plate }}</p>
                </div>
              </div>
              <div class="card-row">
                <div>
                  <p><b>Importe:</b> ${{ formatPrice(multa.cost) }}</p>
                </div>
              </div>
              <div class="card-row">
                <div class="stateCard">
                  <p
                    style="margin-bottom: 0%"
                    class="boton-action"
                    :style="{
                      background: `${getStateColor(multa.currentState.state.state_name)}`,
                    }"
                  >
                    {{
                      capitalizeFirstLetter(multa.currentState.state.state_name)
                    }}
                  </p>
                </div>
                <div class="stateCard">
                  <p
                    style="
                      margin-bottom: 0%;
                      background: transparent;
                      border: 1px solid var(--bg-popup);
                    "
                    class="boton-action"
                  >
                    Ver
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="filteredInfractions.length === 0 && !isMobile"
          class="cardTramites"
          id="noFindCard"
        >
          <div class="card-body" id="noFindCard">
            <h4 style="margin-bottom: 0%">
              No hay multas encontradas en este sistema
            </h4>
          </div>
        </div>
        <div
          v-if="filteredInfractions.length === 0 && isMobile"
          class="cardTramites-mobile"
          id="noFindCard"
        >
          <div class="card-body-mobile" id="noFindCard">
            <h4 style="margin-bottom: 0%">
              No hay multas encontradas en este sistema
            </h4>
          </div>
        </div>

        <div
          v-if="totalPages > 1"
          class="pagination"
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <div class="paginationContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="20"
              viewBox="0 0 19 20"
              fill="none"
              :class="{ disabled: currentPage === 1 }"
              @click="currentPage > 1 ? previousPage() : null"
            >
              <mask
                id="mask0_3798_3758"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="-1"
                y="0"
                width="30"
                height="30"
              >
                <rect
                  x="-0.00830078"
                  y="0.0957031"
                  width="18.9722"
                  height="18.9722"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_3798_3758)" transform="rotate(-180 9.5 10)">
                <path
                  d="M10.2947 9.56866L6.935 6.209C6.80765 6.08163 6.74617 5.92792 6.75055 5.74787C6.75494 5.56781 6.82082 5.4141 6.94818 5.28675C7.07555 5.15939 7.23145 5.0957 7.41591 5.0957C7.60036 5.0957 7.75626 5.15939 7.88361 5.28675L11.7044 9.10754C11.7747 9.1778 11.8241 9.25026 11.8526 9.32493C11.8812 9.39959 11.8954 9.48084 11.8954 9.56866C11.8954 9.6565 11.8812 9.73775 11.8526 9.81241C11.8241 9.88706 11.7747 9.95953 11.7044 10.0298L7.87045 13.8638C7.74309 13.9911 7.58937 14.0526 7.40931 14.0482C7.22925 14.0438 7.07555 13.978 6.94818 13.8506C6.82082 13.7232 6.75714 13.5673 6.75714 13.3829C6.75714 13.1984 6.82082 13.0425 6.94818 12.9152L10.2947 9.56866Z"
                  :fill="currentPage === 1 ? 'transparent' : '#FFFFFF'"
                />
              </g>
            </svg>
            <span>{{ currentPage }} de {{ totalPages }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="20"
              viewBox="0 0 19 20"
              fill="none"
              :class="{ disabled: currentPage === totalPages }"
              @click="currentPage < totalPages ? nextPage() : null"
            >
              <mask
                id="mask0_3798_3758"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="-1"
                y="0"
                width="20"
                height="20"
              >
                <rect
                  x="-0.00830078"
                  y="0.0957031"
                  width="18.9722"
                  height="18.9722"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_3798_3758)">
                <path
                  d="M10.2947 9.56866L6.935 6.209C6.80765 6.08163 6.74617 5.92792 6.75055 5.74787C6.75494 5.56781 6.82082 5.4141 6.94818 5.28675C7.07555 5.15939 7.23145 5.0957 7.41591 5.0957C7.60036 5.0957 7.75626 5.15939 7.88361 5.28675L11.7044 9.10754C11.7747 9.1778 11.8241 9.25026 11.8526 9.32493C11.8812 9.39959 11.8954 9.48084 11.8954 9.56866C11.8954 9.6565 11.8812 9.73775 11.8526 9.81241C11.8241 9.88706 11.7747 9.95953 11.7044 10.0298L7.87045 13.8638C7.74309 13.9911 7.58937 14.0526 7.40931 14.0482C7.22925 14.0438 7.07555 13.978 6.94818 13.8506C6.82082 13.7232 6.75714 13.5673 6.75714 13.3829C6.75714 13.1984 6.82082 13.0425 6.94818 12.9152L10.2947 9.56866Z"
                  :fill="currentPage === totalPages ? 'transparent' : '#FFFFFF'"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="loading l" v-else>
        <div
          class="spinner-grow"
          role="status"
          style="background: var(--color-brand-blue)"
        >
          <span class="sr-only"></span>
        </div>
        <div
          class="spinner-grow"
          role="status"
          style="background: var(--color-brand-blue)"
        >
          <span class="sr-only"></span>
        </div>
        <div
          class="spinner-grow"
          role="status"
          style="background: var(--color-brand-blue)"
        >
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import InfractionService from "@/services/infractions/infractionService";
import { computed, onMounted, reactive, ref, watch, onUnmounted } from "vue";
import InfoInfraComponent from "../Municipal/Infractions/modals/InfoInfraComponent.vue";
import StateService from "@/services/infractions/stateService";

const infractions = ref([]);
let infraction = reactive({});
const loading = ref(false);
const modalInfraction = ref(false);
const searchedQuery = ref("");
const totalPages = ref(1);
const currentPage = ref(1);
const perPage = 6;
const isMobile = ref(window.innerWidth < 768); // Define tu punto de quiebre para móvil

const forceUpdate = () => {
  searchedQuery.value = searchedQuery.value.trim();
};

const fetchInfractionById = async (id) => {
  const response = await InfractionService.getInfractionById(id);
  if (response.success) {
    infraction = response.data.data || {};
  }
};

const InfractionInfo = async (id) => {
  infraction = null;
  loading.value = true;
  await fetchInfractionById(id);
  loading.value = false;
  if (infraction) {
    modalInfraction.value = true;
  }
};

const closeModals = () => {
  modalInfraction.value = false;
};

const formatPrice = (price) => {
  const costAsNumber = parseFloat(price);

  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(costAsNumber);
};

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const getStateColor = (stateName) => {
  const state = StateService.stateAction.find(
    (item) => item.name === stateName,
  );
  return state ? state.color : "#000";
};

const previousPage = async () => {
  if (currentPage.value > 1) {
    currentPage.value -= 1;
    await fetchInfractions();
  }
};

const nextPage = async () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value += 1;
    await fetchInfractions();
  }
};

const filteredInfractions = computed(() => infractions.value ?? []);

const resetPagination = () => {
  currentPage.value = 1;
  totalPages.value = 1;
  fetchInfractions();
};

const fetchInfractions = async () => {
  loading.value = true;
  const query = searchedQuery.value;
  const shoulQuery = searchedQuery.value ? true : false;
  const response =
    query !== "" && shoulQuery
      ? await InfractionService.getByQuery(query, currentPage.value)
      : await InfractionService.getOwnInfractions(currentPage.value);

  if (response.success) {
    infractions.value = response.data.infractions;
    totalPages.value = Math.ceil(response.data.total / perPage);
  } else {
    infractions.value = [];
    totalPages.value = 1;
  }
  loading.value = false;
};

watch(searchedQuery, () => {
  resetPagination();
});

const handleResize = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(() => {
  fetchInfractions();
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
/* Estilos existentes */
.loading {
  width: 25%;
  margin: auto;
  gap: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.paginacion svg {
  width: 25px;
  height: 25px;
}

.activo {
  background: var(--verdePrincipal);
  color: var(--bg-popup);
}

.pagina {
  width: 27px;
  height: 27px;
  padding: 2px 8px;
  border-radius: 75px;
  border: 1px solid var(--bordecard);
  cursor: pointer;
}

.active {
  background: #019939;
}

.pagina p {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

svg {
  cursor: pointer;
}

.stateCard {
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.boton-action {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 4px;
  color: var(--bg-popup);
  font-family: Nunito;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  line-height: 100%;
  letter-spacing: -0.4px;
  border: none;
  max-width: 244px;
}

.card-body {
  background: var(--color-brand-blue);
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 2%;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.cardTramites {
  position: relative;
  border-radius: 10px;
  width: 100%;
  height: 3%;
  color: #ffffff;
  background: var(--color-brand-blue);
  padding: 2px;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  cursor: pointer;
  border: none;
  box-shadow: 0px 2px 4px 0px rgba(97, 97, 97, 0.1);
}

#search {
  width: 40%;
  position: relative;
  height: 20px;
  border-color: transparent;
  background: var(--bg-popup);
  border-radius: 8px;
  outline: none;
}

.form-select {
  display: flex !important;
  width: 85%;
  max-width: 430px;
  --bs-form-select-bg-img: none;
  font-size: 13px;
  border-radius: 7px;
  height: 5%;
  color: var(--text-muted);
  margin-bottom: 3%;
  border: 1px solid #ababab;
  background: var(--bg-popup);
}

.form-select:focus {
  border: 1px solid #ababab;
  box-shadow: none;
}

.filterMultas {
  display: flex;
  justify-content: start;
}

#noFindCard {
  cursor: default;
}

table button {
  padding: 5px 10px;
  cursor: pointer;
}

/* Estilos para las tarjetas en móvil */
.tarjetas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  /* Ajusta el ancho mínimo según necesites */
  gap: 15px;
  margin-top: 20px;
}

.cardTramites-mobile {
  color: #ffffff;
  position: relative;
  border-radius: 10px;
  background: var(--color-brand-blue);
  padding: 20px 22px;
  cursor: pointer;
  border: none;
  box-shadow: 0px 2px 4px 0px rgba(97, 97, 97, 0.1);

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  /* 10px */
  letter-spacing: -0.4px;
}

.card-body-mobile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 7.5px;
}

.card-body-mobile h3 {
  margin-bottom: 10px;
}

.card-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 7.5px;
}

/* estilos para la tabla */
.custom-table {
  width: 100%;
  border-collapse: separate;
  /* Cambia a 'separate' para permitir el espaciado entre celdas */
  border-spacing: 4px 20px;
  color: #ffffff;
  /* Agrega espaciado vertical entre las filas */
}

.custom-table th,
.custom-table td {
  padding: 12px;
  text-align: center;
  height: auto;
}

.custom-table th {
  background-color: #d4145a;
  min-height: 40px;
  border-radius: 9px;
  font-size: 20px;
  font-weight: 800;
  line-height: 90%;
  /*text-align: left; habilitar si se quieren titulos a la izq*/
}

.custom-table td {
  background-color: #4d4d4d;
  border-radius: 9px;
  font-size: 20px;
  font-weight: 800;
  line-height: 90%;

  /* background-color: transparent;
  Elimina el fondo de las celdas del cuerpo */
}

.pagination {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.paginationContainer {
  background: #d4145a;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: #ffffff;
  padding: 0px 5px;
}

@media (max-width: 768px) {
  .filterMultas {
    display: flex;
    justify-content: center;
  }

  #noFindCard {
    justify-content: center;
  }

  .cardTramites {
    /* Estos estilos podrían no aplicarse directamente ya que se usa v-if */
    /* Considera usar estilos más generales o específicos para .cardTramites-mobile */
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 10px;
  }

  .card-body {
    /* Estos estilos podrían no aplicarse directamente ya que se usa v-if */
    flex-direction: column;
    align-items: flex-start;
  }

  .card-body h3 {
    margin-bottom: 0.5rem;
  }
}
</style>
